var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "yto-dialog",
      attrs: {
        title: _vm.step === 2 ? "绑定成功" : "更换头像",
        visible: _vm.isShow,
        "close-on-click-modal": false,
        modal: false,
      },
      on: {
        open: _vm.openDialog,
        close: _vm.closeDialog,
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _vm.step === 2
        ? _c("div", { staticClass: "tip-dialog" }, [
            _c(
              "span",
              { staticClass: "success-icon" },
              [_c("svg-icon", { attrs: { "icon-class": "success" } })],
              1
            ),
            _c("p", { staticClass: "tip-text" }, [_vm._v("头像更换成功！")]),
          ])
        : _c(
            "div",
            [
              _c(
                "el-upload",
                {
                  ref: "uploadFile",
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: "/steward-api/issue/upload",
                    headers: _vm.headers,
                    "show-file-list": false,
                    "before-upload": _vm.beforeAvatarUpload,
                    "on-success": _vm.uploadSuccess,
                  },
                },
                [
                  _vm.imageUrl
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.imageUrl },
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                ]
              ),
              _c("p", { staticClass: "tip-text" }, [
                _vm._v("仅支持JPEG、JPG、PNG图片文件，且文件小于1M。"),
              ]),
            ],
            1
          ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.step === 2
            ? _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.closeDialog } },
                [_vm._v("关 闭")]
              )
            : [
                _c(
                  "el-button",
                  { attrs: { plain: "" }, on: { click: _vm.closeDialog } },
                  [_vm._v("取 消")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.finish } },
                  [_vm._v("确 定")]
                ),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }